<template>

  <div>



    <t-page-form-field-customizable
        v-model="form.fieldCustomizable" :command="command" :status="status"
        :path="path" :primaryKeyColumn="primaryKeyColumn" :foreign-key-column="foreignKeyColumn"
        :primary-key="form.groupProductFieldId" :foreign-key="form.groupProductId"
        :items="items" :user-auth="userAuth"
        :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
        :error-field="error_fieldCustomizable" :general-errors="generalErrors"
        @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault"
        @onCancelUpdatedList="cancelUpdatedField" @onRequestList="getList">

      <template #form-header>

        <b-form-checkbox class="col-sm-6 col-md-6 ml-3" v-model="form.composeProductCode" switch>
          <small>Compõe nome do produto?</small>
          <t-help
              title="Sendo ativado irá compor a criação do nome do produto, caso a opção de criação de nome automatico para produtos for habilitada"/>
        </b-form-checkbox>

      </template>

    </t-page-form-field-customizable>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin";
import pageFormFieldMixin from "@/mixins/page/pageFormFieldMixin";


import tPageFormFieldCustomizable from "@/components/template/page/t-page-form-field-customizable";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin, pageFormFieldMixin],
  components: {tPageFormFieldCustomizable},
  name: 'GroupProductField',
  data() {
    return {
      path: "product/group-product-field", //Utilizar somente quando fora do padrão
      primaryKeyColumn: "groupProductFieldId",
      foreignKeyColumn: "groupProductId", //Utilizar quando usar Tabs com outros componentes
      form: {
        groupProductId: this.foreignKey,
        groupProductFieldId: 0,
        fieldCustomizable: {},
        composeProductCode: true,
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      error: {//Campos que podem receber retorno de erro do backend

      },

      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    typeImage: Boolean,
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormField()


    },

    mountedPrepare() {

      this.defaultForm()
      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.groupProductFieldId)

    },

    mountedList() {

      // Manipulação da listagem após carregando
      //--------------------------------------

      //--------------------------------------

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
